package top.wcpe.allincore.dsl.compiler.parse

import top.wcpe.allincore.dsl.compiler.diag.DslError
import top.wcpe.allincore.dsl.compiler.source.SourcePosition

/**
 * 语法分析阶段的异常。位置信息由 [position] 字段结构化保存，不拼入 message。
 *
 * @property position 触发错误的 token 起始位置（行/列均为 1-based）
 * @property error 触发该异常的细分诊断码；为 null 表示来自旧字符串 fail() 重载。
 *   CompilationPipeline 优先透传该码到 Diagnostic.code，避免被 DSL_E002 覆盖。
 */
class ParseException(
    message: String,
    val position: SourcePosition,
    val error: DslError? = null,
) : RuntimeException(message)
